import { Route, Switch } from 'react-router-dom'

import { Menu } from './Menu'

// import { AdminSettings } from './AdminSettings'
import { Users } from './Users'
import { Mountpoints } from './Mountpoints'
import Measurments from './Measurments'
import { LogViewer } from 'log-viewer/LogViewer'
import { Permissions } from './Permissions'
import { UserProfile } from './UserProfile'
import { UserStats } from './UserStats'
import { MountpointInfo } from './MountpointInfo'
import { MountpointStats } from './MountpointStats'
// import MountpointSatellites from './MountpointSatellites'
// import SatellitesCount from './MountpointSatellitesHistory/SatellitesCount'
// import SatelliteSignals from './MountpointSatellitesHistory/SatelliteSignals'
import { Server } from './Server'

import { makeStyles } from '@material-ui/core/styles'
// import RinexList from './RinexService/RinexList'
import MapStatusBar from 'Map/MapStatusBar'
// import UserHistory from './UserHistory'
// import RinexForm from './RinexService/RinexForm'
import MountpointLogs from './MountpointLogs'

export function Side() {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Menu />
      <div className={classes.content}>
        <Switch>
          <Route path="/" component={MapStatusBar} exact />
          {/* <Route path="/admin-settings" component={AdminSettings} /> */}
          <Route path="/users" component={Users} />
          {/*<Route path="/rinex/new" component={RinexForm} />*/}
          {/*<Route path="/rinex/list" component={RinexList} />*/}
          <Route path="/mountpoints" component={Mountpoints} />
          <Route path="/measurement" component={Measurments} />
          <Route path="/logs" component={LogViewer} />
          <Route path="/permissions" component={Permissions} />
          <Route path="/user/:userId/profile" component={UserProfile} />
          <Route path="/user/:userId/stats" component={UserStats} />
          {/*<Route path="/user/:userId/history" component={UserHistory} />*/}
          <Route path="/mountpoint/:mid/stats" component={MountpointStats} />
          {/*<Route*/}
          {/*  path="/mountpoint/:mid/satellites"*/}
          {/*  component={MountpointSatellites}*/}
          {/*/>*/}
          {/*<Route*/}
          {/*  path="/mountpoint/:mid/satellites-count"*/}
          {/*  component={SatellitesCount}*/}
          {/*/>*/}
          {/*<Route*/}
          {/*  path="/mountpoint/:mid/satellite-signals"*/}
          {/*  component={SatelliteSignals}*/}
          {/*/>*/}
          <Route path="/mountpoint/:mid/info" component={MountpointInfo} />
          <Route path="/mountpoint/:mid/logs" component={MountpointLogs} />
          <Route path="/server" component={Server} />
        </Switch>
      </div>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    minWidth: 450,
    maxWidth: 480,
    maxHeight: '100dvh',
    display: 'flex',
    flexFlow: 'column',
    padding: theme.spacing(1),
    left: 0,
    zIndex: 5,
    [theme.breakpoints.down('xs')]: {
      minWidth: 'unset',
      maxWidth: 'unset',
      width: '100%',
    },
  },
  content: {
    width: '100%',
    maxHeight: `calc(100dvh - 48px - ${theme.spacing(3)}px)`, // minus height of menu
    marginTop: 3,
    display: 'flex',
    flexFlow: 'column',
  },
}))
